import { AlmaUrls } from '~/components/AccountGetsMarried/constants/alma';

export type ConsumerService = {
  categorySlug: string;
  subCategorySlug: string;
  name: string;
  description?: string;
  slug: string;
  inPerson?: boolean;
  telemed?: boolean;
  symptomChecker?: boolean;
  asyncChat?: boolean;
  serviceIds?: string;
  assumeOfferedByAllClinics: boolean;
  popular: boolean;
  hidden?: boolean;
  svg?: string;
  shortName?: string;
  href?: string;
  externalLink?: boolean;
  sortOrder?: number;
};
export const consumerServices: ReadonlyArray<ConsumerService> = [
  {
    subCategorySlug: 'childrens/allergies',
    categorySlug: 'childrens',
    name: 'Allergy blood test',
    description: '',
    slug: 'allergy-blood-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '92MQAO,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Allergy blood test',
  },
  {
    subCategorySlug: 'childrens/allergies',
    categorySlug: 'childrens',
    name: 'Allergy skin prick test',
    description: '',
    slug: 'allergy-skin-prick-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '90jQMp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Allergy skin prick',
  },
  {
    subCategorySlug: 'childrens/allergies',
    categorySlug: 'childrens',
    name: 'Allergy treatment',
    description: '',
    slug: 'allergy-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9xnzyp,9AY009,9W2QlO,gbPD0O,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Allergy treatment',
  },
  {
    subCategorySlug: 'childrens/allergies',
    categorySlug: 'childrens',
    name: 'Asthma treatment',
    description: '',
    slug: 'asthma-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '59eeV9,OJe08p,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Asthma treatment',
  },
  {
    subCategorySlug: 'childrens/allergies',
    categorySlug: 'childrens',
    name: 'Eczema treatment (Atopic dermatitis)',
    description: '',
    slug: 'eczema-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O67Vj9,ODGmWp,gY56vg',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'eczema.svg',
    shortName: 'Eczema treatment',
  },
  {
    subCategorySlug: 'childrens/allergies',
    categorySlug: 'childrens',
    name: 'Food allergy test',
    description: '',
    slug: 'food-allergy-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O67xJ9,pvNWBp,OrdzBg,92MQAO,90jQMp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Food allergy test',
  },
  {
    subCategorySlug: 'childrens/allergies',
    categorySlug: 'childrens',
    name: 'Hay fever treatment',
    description: '',
    slug: 'hay-fever-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p8rMQ9,p3Mjq9,gMmnzg,pdE7YO,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Hay fever treatment',
  },
  {
    subCategorySlug: 'childrens/allergies',
    categorySlug: 'childrens',
    name: 'Pet allergy treatment',
    description: '',
    slug: 'pet-allergy-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gY5z2g,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Pet allergy treatment',
  },
  {
    subCategorySlug: 'childrens/allergies',
    categorySlug: 'childrens',
    name: 'Seasonal allergy treatment',
    description: '',
    slug: 'seasonal-allergy-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p8rMQ9,p3Mjq9,gMmnzg,pdE7YO,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Seasonal allergy treatment',
  },
  {
    subCategorySlug: 'childrens/physicals',
    categorySlug: 'childrens',
    name: 'Camp physical',
    description: '',
    slug: 'camp-physical',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gMmmNg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Camp physical',
  },
  {
    subCategorySlug: 'childrens/physicals',
    categorySlug: 'childrens',
    name: 'Eye exam',
    description: '',
    slug: 'eye-exam',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gbPvxO,9nvN39',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Eye exam',
  },
  {
    subCategorySlug: 'childrens/physicals',
    categorySlug: 'childrens',
    name: 'School physical',
    description: '',
    slug: 'school-physical',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Vg7v9M',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'School physical',
  },
  {
    subCategorySlug: 'childrens/physicals',
    categorySlug: 'childrens',
    name: 'Sports physical',
    description: '',
    slug: 'sports-physical',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Vg7v9M',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Sports physical',
  },
  {
    subCategorySlug: 'childrens/physicals',
    categorySlug: 'childrens',
    name: 'Vision test',
    description: '',
    slug: 'vision-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Yp8YEO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Vision test',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Bee sting treatment',
    description: '',
    slug: 'bee-sting-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'OQoVZg,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Bee sting treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Broken bone treatment (splinting & casting)',
    description: '',
    slug: 'broken-bone-treatment-splinting-casting',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'RpR7WO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Broken bone treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Burn treatment',
    description: '',
    slug: 'burn-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '7OX7op,qgMP9o,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Burn treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Canker, cold & mouth sore treatment',
    description: '',
    slug: 'canker-cold-mouth-sore-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'canker_cold_sore.svg',
    shortName: 'Cold sore treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Cold & upper respiratory infection treatment',
    description: '',
    slug: 'cold-respiratory-infection-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,pylzqg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Upper respiratory infection',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Congestion & sinus infection treatment',
    description: '',
    slug: 'congestion-sinus-infection-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O4Pw2O,pdEvQO,pylzqg',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'sinus.svg',
    shortName: 'Sinus infection',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Constipation treatment',
    description: '',
    slug: 'constipation-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Constipation treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Cough & bronchitis treatment',
    description: '',
    slug: 'cough-bronchitis-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,pylzqg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Bronchitis treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Diarrhea treatment',
    description: '',
    slug: 'diarrhea-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Diarrhea treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Ear infection & earache treatment',
    description: '',
    slug: 'ear-infection-earache-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Ear infection treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Earwax removal',
    description: '',
    slug: 'ear-wax-removal',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'ag124p,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'earwax_removal.svg',
    shortName: 'Earwax removal',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Eye infection treatment',
    description: '',
    slug: 'eye-infection-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gMm5zg,OlqVG9,pdEvQO,9nvN39',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Eye infection treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Flu-like symptoms treatment',
    description: '',
    slug: 'flu-symptoms-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Flu-like symptoms treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Foreign body removal',
    description: '',
    slug: 'foreign-body-removal',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p3MXE9',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Foreign body removal',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Hives treatment',
    description: '',
    slug: 'hives-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9qGB4p,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Hives treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Insect sting treatment',
    description: '',
    slug: 'insect-sting-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gmYLvg,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Insect sting treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Nausea & vomiting treatment',
    description: '',
    slug: 'nausea-vomiting-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Nausea & vomiting treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Pink eye treatment',
    description: '',
    slug: 'pink-eye-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pGR73g,gMm5zg,OlqVG9,pdEvQO,9nvN39',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'pink_eye.svg',
    shortName: 'Pink eye treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Respiratory syncytial virus test (RSV)',
    description: '',
    slug: 'rsv-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'M9Zwqg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'RSV test',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Sore & strep throat treatment',
    description: '',
    slug: 'sore-strep-throat-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Strep throat treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Stitches (laceration repair)',
    description: '',
    slug: 'stitches-laceration-repair',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Vg7Bv9,qgMP9o',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Stitches',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Sunburn treatment',
    description: '',
    slug: 'sunburn-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '7OX7op,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Sunburn treatment',
  },
  {
    subCategorySlug: 'childrens/sickness-injury',
    categorySlug: 'childrens',
    name: 'Wound care',
    description: '',
    slug: 'wound-care',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'qgMP9o,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Wound care',
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: 'Acne treatment',
    description: '',
    slug: 'acne-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'OrdkBg,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Acne treatment',
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: "Athlete's foot treatment",
    description: '',
    slug: 'athlete-foot-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: "Athlete's foot treatment",
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: 'Bug bite treatment',
    description: '',
    slug: 'bug-bite-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Bug bite treatment',
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: 'Chickenpox treatment',
    description: '',
    slug: 'chickenpox-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Chickenpox treatment',
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: 'Dermatitis treatment',
    description: '',
    slug: 'dermatitis-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzoQEO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Dermatitis treatment',
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: 'Impetigo treatment',
    description: '',
    slug: 'impetigo-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Impetigo treatment',
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: 'Poisonous plant rash treatment (Ivy, Oak, Sumac)',
    description: '',
    slug: 'poisonous-plant-rash-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Poison ivy treatment',
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: 'Rash consultation',
    description: '',
    slug: 'rash-consultation',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEyYO,goknag,,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Rash consultation',
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: 'Ringworm treatment',
    description: '',
    slug: 'ringworm-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'ring_worm.svg',
    shortName: 'Ringworm treatment',
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: 'Tick bite treatment',
    description: '',
    slug: 'tick-bite-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Tick bite treatment',
  },
  {
    subCategorySlug: 'childrens/skin-health',
    categorySlug: 'childrens',
    name: 'Wart evaluation',
    description: '',
    slug: 'wart-evaluation',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,9L4VN9',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Wart evaluation',
  },
  {
    subCategorySlug: 'childrens/vaccinations',
    categorySlug: 'childrens',
    name: 'Chickenpox vaccine',
    description: '',
    slug: 'chickenpox-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEEBO,pvNN2p',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Chickenpox vaccine',
  },
  {
    subCategorySlug: 'childrens/vaccinations',
    categorySlug: 'childrens',
    name: 'DTaP vaccine (Diphtheria, Tetanus, Pertussis)',
    description: '',
    slug: 'dtap-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Olqqy9,pvNN2p',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'DTaP vaccine',
  },
  {
    subCategorySlug: 'childrens/vaccinations',
    categorySlug: 'childrens',
    name: 'Flu vaccine',
    description: '',
    slug: 'flu-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'n9wG9K,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Flu vaccine',
  },
  {
    subCategorySlug: 'childrens/vaccinations',
    categorySlug: 'childrens',
    name: 'HPV vaccine (Human Papillomavirus)',
    description: '',
    slug: 'hpv-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9AYln9,pvNN2p',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'HPV vaccine',
  },
  {
    subCategorySlug: 'childrens/vaccinations',
    categorySlug: 'childrens',
    name: 'Measles vaccine',
    description: '',
    slug: 'measles-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9L44e9,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Measles vaccine',
  },
  {
    subCategorySlug: 'childrens/vaccinations',
    categorySlug: 'childrens',
    name: 'Tetanus vaccine',
    description: '',
    slug: 'tetanus-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '8pEqpX,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Tetanus vaccine',
  },
  {
    subCategorySlug: 'chronic/asthma',
    categorySlug: 'chronic',
    name: 'Asthma treatment',
    description: '',
    slug: 'asthma-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '59eeV9,OJe08p,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'asthma.svg',
    shortName: 'Asthma treatment',
  },
  {
    subCategorySlug: 'chronic/asthma',
    categorySlug: 'chronic',
    name: 'Breathing treatment',
    description: '',
    slug: 'breathing-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'BgBe9X,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Breathing treatment',
  },
  {
    subCategorySlug: 'chronic/asthma',
    categorySlug: 'chronic',
    name: 'Exercise-induced asthma treatment',
    description: '',
    slug: 'exercise-induced-asthma-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9nv439',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Exercise-induced asthma',
  },
  {
    subCategorySlug: 'chronic/autoimmune',
    categorySlug: 'chronic',
    name: 'Eosinophilic esophagitis treatment',
    description: '',
    slug: 'eosinophilic-esophagitis-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pEZG6O',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Eosinophilic esophagitis',
  },
  {
    subCategorySlug: 'chronic/autoimmune',
    categorySlug: 'chronic',
    name: 'Psoriasis treatment',
    description: '',
    slug: 'psoriasis-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gB70Qp',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'psoriasis.svg',
    shortName: 'Psoriasis treatment',
  },
  {
    subCategorySlug: 'chronic/diabetes',
    categorySlug: 'chronic',
    name: 'A1C test (blood sugar levels)',
    description: '',
    slug: 'a1c-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'g7zxY9,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'A1C test',
  },
  {
    subCategorySlug: 'chronic/diabetes',
    categorySlug: 'chronic',
    name: 'Diabetes test',
    description: '',
    slug: 'diabetes-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pEZVyO,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Diabetes test',
  },
  {
    subCategorySlug: 'chronic/diabetes',
    categorySlug: 'chronic',
    name: 'Glucose test',
    description: '',
    slug: 'glucose-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '692V9w,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Glucose test',
  },
  {
    subCategorySlug: 'chronic/diabetes',
    categorySlug: 'chronic',
    name: 'IV hydration',
    description: '',
    slug: 'iv-hydration',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'lgbRgQ',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'IV hydration',
  },
  {
    subCategorySlug: 'chronic/diabetes',
    categorySlug: 'chronic',
    name: 'Urinalysis',
    description: '',
    slug: 'urinalysis',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'ag149D,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Urinalysis',
  },
  {
    subCategorySlug: 'chronic/gout',
    categorySlug: 'chronic',
    name: 'Gout treatment',
    description: '',
    slug: 'gout-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'gout.svg',
    shortName: 'Gout treatment',
  },
  {
    subCategorySlug: 'chronic/heart-conditions',
    categorySlug: 'chronic',
    name: 'Blood pressure test',
    description: '',
    slug: 'blood-pressure-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Blood pressure test',
  },
  {
    subCategorySlug: 'chronic/heart-conditions',
    categorySlug: 'chronic',
    name: 'EKG test',
    description: '',
    slug: 'ekg-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'qpd2N9',
    assumeOfferedByAllClinics: false,
    popular: true,
    hidden: false,
    svg: 'ekg.svg',
    shortName: 'EKG test',
  },
  {
    subCategorySlug: 'chronic/respiratory',
    categorySlug: 'chronic',
    name: 'COPD screening (pulmonary function test)',
    description: '',
    slug: 'copd-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'lgb5W9',
    assumeOfferedByAllClinics: false,
    popular: true,
    hidden: false,
    svg: 'pulmonary.svg',
    shortName: 'COPD screening',
  },
  {
    subCategorySlug: 'chronic/respiratory',
    categorySlug: 'chronic',
    name: 'Spirometry test',
    description: '',
    slug: 'spirometry-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gaYyGg',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Spirometry test',
  },
  {
    subCategorySlug: 'chronic/thyroid',
    categorySlug: 'chronic',
    name: 'Thyroid disease screening',
    description: '',
    slug: 'thyroid-disease-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Ojx2ng,M9ZYmO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Thyroid disease screening',
  },
  {
    subCategorySlug: 'covid/covid-test',
    categorySlug: 'covid',
    name: 'COVID-19 antibody test',
    description: '',
    slug: 'covid-antibody-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pPooAg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 antibody test',
  },
  {
    subCategorySlug: 'covid/covid-test',
    categorySlug: 'covid',
    name: 'COVID-19 antigen test',
    description: '',
    slug: 'covid-antigen-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pvN7yp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 antigen test',
  },
  {
    subCategorySlug: 'covid/covid-test',
    categorySlug: 'covid',
    name: 'COVID-19 PCR test',
    description: '',
    slug: 'covid-pcr-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9nvZo9,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 PCR test',
  },
  {
    subCategorySlug: 'covid/covid-test',
    categorySlug: 'covid',
    name: 'Rapid COVID-19 antigen test',
    description: '',
    slug: 'rapid-covid-antigen-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Ord20g,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Rapid COVID-19 antigen test',
  },
  {
    subCategorySlug: 'covid/covid-test',
    categorySlug: 'covid',
    name: 'Rapid COVID-19 PCR test',
    description: '',
    slug: 'rapid-covid-pcr-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Olq1m9,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Rapid COVID-19 PCR test',
  },
  {
    subCategorySlug: 'covid/covid-treatment',
    categorySlug: 'covid',
    name: 'COVID-19 treatment',
    description: '',
    slug: 'covid-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pPob5g,9AY4k9,9VJwM9,9kqWap,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 treatment',
  },
  {
    subCategorySlug: 'covid/covid-vaccines',
    categorySlug: 'covid',
    name: 'COVID-19 booster',
    description: '',
    slug: 'covid-booster',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9K1eBp,9qG5Kp,9L41d9,gmYrng',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 booster',
  },
  {
    subCategorySlug: 'covid/covid-vaccines',
    categorySlug: 'covid',
    name: 'COVID-19 vaccine',
    description: '',
    slug: 'covid-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9K1eBp,9qG5Kp,9L41d9,gmYrng',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 vaccine',
  },
  {
    subCategorySlug: 'illness-infection/allergies',
    categorySlug: 'illness-infection',
    name: 'Allergy treatment',
    description: '',
    slug: 'allergy-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9xnzyp,9AY009,9W2QlO,gbPD0O,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Allergy treatment',
  },
  {
    subCategorySlug: 'illness-infection/allergies',
    categorySlug: 'illness-infection',
    name: 'Anaphylaxis treatment (severe allergic reaction)',
    description: '',
    slug: 'anaphylaxis-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gokyjg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Anaphylaxis treatment',
  },
  {
    subCategorySlug: 'illness-infection/allergies',
    categorySlug: 'illness-infection',
    name: 'Angioedema treatment (skin swelling)',
    description: '',
    slug: 'angioedema-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gB7mkp',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Angioedema treatment',
  },
  {
    subCategorySlug: 'illness-infection/allergies',
    categorySlug: 'illness-infection',
    name: 'Aspirin allergy treatment',
    description: '',
    slug: 'aspirin-allergy-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pRoA0O',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Aspirin allergy treatment',
  },
  {
    subCategorySlug: 'illness-infection/allergies',
    categorySlug: 'illness-infection',
    name: 'Breathing treatment',
    description: '',
    slug: 'breathing-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'BgBe9X,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Breathing treatment',
  },
  {
    subCategorySlug: 'illness-infection/allergies',
    categorySlug: 'illness-infection',
    name: 'Hay fever treatment',
    description: '',
    slug: 'hay-fever-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p8rMQ9,p3Mjq9,gMmnzg,pdE7YO,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Hay fever treatment',
  },
  {
    subCategorySlug: 'illness-infection/allergies',
    categorySlug: 'illness-infection',
    name: 'Pet allergy treatment',
    description: '',
    slug: 'pet-allergy-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gY5z2g,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Pet allergy treatment',
  },
  {
    subCategorySlug: 'illness-infection/allergies',
    categorySlug: 'illness-infection',
    name: 'Seasonal allergy treatment',
    description: '',
    slug: 'seasonal-allergy-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p8rMQ9,p3Mjq9,gMmnzg,pdE7YO,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Seasonal allergy treatment',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Cold & upper respiratory infection treatment',
    description: '',
    slug: 'cold-respiratory-infection-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,pylzqg',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'cold.svg',
    shortName: 'Upper respiratory infection',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Congestion & sinus infection treatment',
    description: '',
    slug: 'congestion-sinus-infection-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O4Pw2O,pdEvQO,pylzqg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Sinus infection treatment',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Cough & bronchitis treatment',
    description: '',
    slug: 'cough-bronchitis-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,pylzqg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Bronchitis treatment',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'COVID-19 treatment',
    description: '',
    slug: 'covid-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pPob5g,9AY4k9,9VJwM9,9kqWap,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 treatment',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Flu test',
    description: '',
    slug: 'flu-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'XO6RO1,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Flu test',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Flu-like symptoms treatment',
    description: '',
    slug: 'flu-symptoms-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Flu-like symptoms treatment',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Mono test (Mononucleosis)',
    description: '',
    slug: 'mono-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '7OXVog,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Mono test',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Mono treatment (Mononucleosis)',
    description: '',
    slug: 'mono-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Mono treatment',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Respiratory syncytial virus test (RSV)',
    description: '',
    slug: 'rsv-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'M9Zwqg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'RSV test',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Sore & strep throat treatment',
    description: '',
    slug: 'sore-strep-throat-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'sore_throat.svg',
    shortName: 'Sore throat treatment',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Strep throat test',
    description: '',
    slug: 'strep-throat-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'LOQ0p1,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Strep throat test',
  },
  {
    subCategorySlug: 'illness-infection/cold-strep-sinus-flu',
    categorySlug: 'illness-infection',
    name: 'Tuberculosis (TB) test',
    description: '',
    slug: 'tb-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '09nR9x,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Tuberculosis (TB) test',
  },
  {
    subCategorySlug: 'illness-infection/covid-19',
    categorySlug: 'illness-infection',
    name: 'COVID-19 antibody test',
    description: '',
    slug: 'covid-antibody-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pPooAg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 antibody test',
  },
  {
    subCategorySlug: 'illness-infection/covid-19',
    categorySlug: 'illness-infection',
    name: 'COVID-19 antigen test',
    description: '',
    slug: 'covid-antigen-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pvN7yp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 antigen test',
  },
  {
    subCategorySlug: 'illness-infection/covid-19',
    categorySlug: 'illness-infection',
    name: 'COVID-19 PCR test',
    description: '',
    slug: 'covid-pcr-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9nvZo9,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 PCR test',
  },
  {
    subCategorySlug: 'illness-infection/covid-19',
    categorySlug: 'illness-infection',
    name: 'COVID-19 treatment',
    description: '',
    slug: 'covid-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pPob5g,9AY4k9,9VJwM9,9kqWap,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 treatment',
  },
  {
    subCategorySlug: 'illness-infection/covid-19',
    categorySlug: 'illness-infection',
    name: 'Rapid COVID-19 antigen test',
    description: '',
    slug: 'rapid-covid-antigen-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Ord20g,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Rapid COVID-19 antigen test',
  },
  {
    subCategorySlug: 'illness-infection/covid-19',
    categorySlug: 'illness-infection',
    name: 'Rapid COVID-19 PCR test',
    description: '',
    slug: 'rapid-covid-pcr-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Olq1m9,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Rapid COVID-19 PCR test',
  },
  {
    subCategorySlug: 'illness-infection/dehydration-heat-exhaustion',
    categorySlug: 'illness-infection',
    name: 'Heatstroke treatment',
    description: '',
    slug: 'heatstroke-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Heatstroke treatment',
  },
  {
    subCategorySlug: 'illness-infection/dehydration-heat-exhaustion',
    categorySlug: 'illness-infection',
    name: 'IV hydration',
    description: '',
    slug: 'iv-hydration',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'lgbRgQ',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'IV hydration',
  },
  {
    subCategorySlug: 'illness-infection/eye-ear',
    categorySlug: 'illness-infection',
    name: 'Dry eyes treatment',
    description: '',
    slug: 'dry-eyes-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pRo6rO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Dry eyes treatment',
  },
  {
    subCategorySlug: 'illness-infection/eye-ear',
    categorySlug: 'illness-infection',
    name: 'Ear infection & earache treatment',
    description: '',
    slug: 'ear-infection-earache-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'ear_infection.svg',
    shortName: 'Ear infection treatment',
  },
  {
    subCategorySlug: 'illness-infection/eye-ear',
    categorySlug: 'illness-infection',
    name: 'Ear wax removal',
    description: '',
    slug: 'ear-wax-removal',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'ag124p,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Ear wax removal',
  },
  {
    subCategorySlug: 'illness-infection/eye-ear',
    categorySlug: 'illness-infection',
    name: 'Eye infection treatment',
    description: '',
    slug: 'eye-infection-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gMm5zg,OlqVG9,pdEvQO,9nvN39',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Eye infection treatment',
  },
  {
    subCategorySlug: 'illness-infection/eye-ear',
    categorySlug: 'illness-infection',
    name: 'Eye stye treatment',
    description: '',
    slug: 'eye-stye-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,9nvN39',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Eye stye treatment',
  },
  {
    subCategorySlug: 'illness-infection/eye-ear',
    categorySlug: 'illness-infection',
    name: 'Pink eye treatment',
    description: '',
    slug: 'pink-eye-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pGR73g,gMm5zg,OlqVG10,pdEvQO,9nvN39',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Pink eye treatment',
  },
  {
    subCategorySlug: 'illness-infection/mouth-ulcers',
    categorySlug: 'illness-infection',
    name: 'Canker, cold & mouth sore treatment',
    description: '',
    slug: 'canker-cold-mouth-sore-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Cold sore treatment',
  },
  {
    subCategorySlug: 'illness-infection/mouth-ulcers',
    categorySlug: 'illness-infection',
    name: 'Mouth pain & discomfort treatment',
    description: '',
    slug: 'mouth-pain-discomfort-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Mouth pain & discomfort',
  },
  {
    subCategorySlug: 'illness-infection/sti',
    categorySlug: 'illness-infection',
    name: 'Chlamydia test',
    description: '',
    slug: 'chlamydia-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'g7zPY9,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Chlamydia test',
  },
  {
    subCategorySlug: 'illness-infection/sti',
    categorySlug: 'illness-infection',
    name: 'Chlamydia treatment',
    description: '',
    slug: 'chlamydia-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Chlamydia treatment',
  },
  {
    subCategorySlug: 'illness-infection/sti',
    categorySlug: 'illness-infection',
    name: 'Genital herpes treatment',
    description: '',
    slug: 'genital-herpes-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Genital herpes treatment',
  },
  {
    subCategorySlug: 'illness-infection/sti',
    categorySlug: 'illness-infection',
    name: 'Gonorrhea test',
    description: '',
    slug: 'gonorrhea-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O4PoVO,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Gonorrhea test',
  },
  {
    subCategorySlug: 'illness-infection/sti',
    categorySlug: 'illness-infection',
    name: 'Gonorrhea treatment',
    description: '',
    slug: 'gonorrhea-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Gonorrhea treatment',
  },
  {
    subCategorySlug: 'illness-infection/sti',
    categorySlug: 'illness-infection',
    name: 'Herpes test',
    description: '',
    slug: 'herpes-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'OjxWng,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Herpes test',
  },
  {
    subCategorySlug: 'illness-infection/sti',
    categorySlug: 'illness-infection',
    name: 'HIV screening',
    description: '',
    slug: 'hiv-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzo7AO,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'HIV screening',
  },
  {
    subCategorySlug: 'illness-infection/sti',
    categorySlug: 'illness-infection',
    name: 'Syphilis test',
    description: '',
    slug: 'syphilis-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9Zd7Gp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Syphilis test',
  },
  {
    subCategorySlug: 'illness-infection/sti',
    categorySlug: 'illness-infection',
    name: 'Trichomonas test',
    description: '',
    slug: 'trichomonas-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'x9VQeO,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Trichomonas test',
  },
  {
    subCategorySlug: 'illness-infection/skin-infection',
    categorySlug: 'illness-infection',
    name: 'Abscess treatment',
    description: '',
    slug: 'abscess-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'V9WG09,9L4VN9',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Abscess treatment',
  },
  {
    subCategorySlug: 'illness-infection/skin-infection',
    categorySlug: 'illness-infection',
    name: "Athlete's foot treatment",
    description: '',
    slug: 'athlete-foot-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: "Athlete's foot treatment",
  },
  {
    subCategorySlug: 'illness-infection/skin-infection',
    categorySlug: 'illness-infection',
    name: 'Cellulitis treatment',
    description: '',
    slug: 'cellulitis-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Cellulitis treatment',
  },
  {
    subCategorySlug: 'illness-infection/skin-infection',
    categorySlug: 'illness-infection',
    name: 'Chickenpox treatment',
    description: '',
    slug: 'chickenpox-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Chickenpox treatment',
  },
  {
    subCategorySlug: 'illness-infection/skin-infection',
    categorySlug: 'illness-infection',
    name: 'Impetigo treatment',
    description: '',
    slug: 'impetigo-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Impetigo treatment',
  },
  {
    subCategorySlug: 'illness-infection/skin-infection',
    categorySlug: 'illness-infection',
    name: 'Ringworm treatment',
    description: '',
    slug: 'ringworm-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'ring_worm.svg',
    shortName: 'Ringworm treatment',
  },
  {
    subCategorySlug: 'illness-infection/skin-infection',
    categorySlug: 'illness-infection',
    name: 'Shingles treatment',
    description: '',
    slug: 'shingles-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Shingles treatment',
  },
  {
    subCategorySlug: 'illness-infection/skin-infection',
    categorySlug: 'illness-infection',
    name: 'Shingles vaccine',
    description: '',
    slug: 'shingles-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9K11Np,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Shingles vaccine',
  },
  {
    subCategorySlug: 'illness-infection/skin-infection',
    categorySlug: 'illness-infection',
    name: 'Skin infection treatment',
    description: '',
    slug: 'skin-infection-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Skin infection treatment',
  },
  {
    subCategorySlug: 'illness-infection/stomach-digestive',
    categorySlug: 'illness-infection',
    name: 'Constipation treatment',
    description: '',
    slug: 'constipation-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Constipation treatment',
  },
  {
    subCategorySlug: 'illness-infection/stomach-digestive',
    categorySlug: 'illness-infection',
    name: 'Diarrhea treatment',
    description: '',
    slug: 'diarrhea-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Diarrhea treatment',
  },
  {
    subCategorySlug: 'illness-infection/stomach-digestive',
    categorySlug: 'illness-infection',
    name: 'Heartburn & indigestion treatment',
    description: '',
    slug: 'heartburn-indigestion-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'heart_burn.svg',
    shortName: 'Heartburn & indigestion',
  },
  {
    subCategorySlug: 'illness-infection/stomach-digestive',
    categorySlug: 'illness-infection',
    name: 'Helicobacter pylori (H. pylori) test',
    description: '',
    slug: 'helicobacter-pylori-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'lgb5R9,M9ZYmO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'H. pylori test',
  },
  {
    subCategorySlug: 'illness-infection/stomach-digestive',
    categorySlug: 'illness-infection',
    name: 'Nausea & vomiting treatment',
    description: '',
    slug: 'nausea-vomiting-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Nausea & vomiting treatment',
  },
  {
    subCategorySlug: 'illness-infection/uti',
    categorySlug: 'illness-infection',
    name: 'Bladder infection treatment',
    description: '',
    slug: 'bladder-infection-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Bladder infection treatment',
  },
  {
    subCategorySlug: 'illness-infection/uti',
    categorySlug: 'illness-infection',
    name: 'Urinary tract infection treatment (UTI)',
    description: '',
    slug: 'uti-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'uti.svg',
    shortName: 'UTI treatment',
  },
  {
    subCategorySlug: 'injury-pain/aches-pains',
    categorySlug: 'injury-pain',
    name: 'Gout treatment',
    description: '',
    slug: 'gout-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'gout.svg',
    shortName: 'Gout treatment',
  },
  {
    subCategorySlug: 'injury-pain/aches-pains',
    categorySlug: 'injury-pain',
    name: 'Headache & migraine treatment',
    description: '',
    slug: 'headache-migraine-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'headache.svg',
    shortName: 'Headache & migraine',
  },
  {
    subCategorySlug: 'injury-pain/aches-pains',
    categorySlug: 'injury-pain',
    name: 'Pelvic pain evaluation',
    description: '',
    slug: 'pelvic-pain-evaluation',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Pelvic pain evaluation',
  },
  {
    subCategorySlug: 'injury-pain/bites-stings',
    categorySlug: 'injury-pain',
    name: 'Animal bite treatment',
    description: '',
    slug: 'animal-bite-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Animal bite treatment',
  },
  {
    subCategorySlug: 'injury-pain/bites-stings',
    categorySlug: 'injury-pain',
    name: 'Bee sting treatment',
    description: '',
    slug: 'bee-sting-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'OQoVZg,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Bee sting treatment',
  },
  {
    subCategorySlug: 'injury-pain/bites-stings',
    categorySlug: 'injury-pain',
    name: 'Bug bite treatment',
    description: '',
    slug: 'bug-bite-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'bug_bite.svg',
    shortName: 'Bug bites',
  },
  {
    subCategorySlug: 'injury-pain/bites-stings',
    categorySlug: 'injury-pain',
    name: 'Tick bite treatment',
    description: '',
    slug: 'tick-bite-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Tick bite treatment',
  },
  {
    subCategorySlug: 'injury-pain/bites-stings',
    categorySlug: 'injury-pain',
    name: 'Venom test',
    description: '',
    slug: 'venom-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p5BmbO,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Venom test',
  },
  {
    subCategorySlug: 'injury-pain/burns-blisters',
    categorySlug: 'injury-pain',
    name: 'Burn treatment',
    description: '',
    slug: 'burn-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '7OX7op,qgMP9o,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Burn treatment',
  },
  {
    subCategorySlug: 'injury-pain/burns-blisters',
    categorySlug: 'injury-pain',
    name: 'Sunburn treatment',
    description: '',
    slug: 'sunburn-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '7OX7op,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Sunburn treatment',
  },
  {
    subCategorySlug: 'injury-pain/cuts-wounds',
    categorySlug: 'injury-pain',
    name: 'Scar treatment',
    description: '',
    slug: 'scar-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9W2wAO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Scar treatment',
  },
  {
    subCategorySlug: 'injury-pain/cuts-wounds',
    categorySlug: 'injury-pain',
    name: 'Stitches (laceration repair)',
    description: '',
    slug: 'stitches-laceration-repair',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Vg7Bv9,qgMP9o',
    assumeOfferedByAllClinics: false,
    popular: true,
    hidden: false,
    svg: 'stitches.svg',
    shortName: 'Stitches',
  },
  {
    subCategorySlug: 'injury-pain/cuts-wounds',
    categorySlug: 'injury-pain',
    name: 'Wound care',
    description: '',
    slug: 'wound-care',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'qgMP9o,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Wound care',
  },
  {
    subCategorySlug: 'injury-pain/foreign-removal',
    categorySlug: 'injury-pain',
    name: 'Foreign body removal',
    description: '',
    slug: 'foreign-body-removal',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p3MXE9',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Foreign body removal',
  },
  {
    subCategorySlug: 'injury-pain/sprains-strains-breaks',
    categorySlug: 'injury-pain',
    name: 'Broken bone treatment (splinting & casting)',
    description: '',
    slug: 'broken-bone-treatment-splinting-casting',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'RpR7WO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Broken bone treatment',
  },
  {
    subCategorySlug: 'injury-pain/sprains-strains-breaks',
    categorySlug: 'injury-pain',
    name: 'Sprain & strain treatment',
    description: '',
    slug: 'sprain-strain-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Sprain & strain treatment',
  },
  {
    subCategorySlug: 'injury-pain/sprains-strains-breaks',
    categorySlug: 'injury-pain',
    name: 'X-ray (chest)',
    description: '',
    slug: 'x-ray-chest',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pGRbxg',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'X-ray (chest)',
  },
  {
    subCategorySlug: 'injury-pain/sprains-strains-breaks',
    categorySlug: 'injury-pain',
    name: 'X-ray (extremity)',
    description: '',
    slug: 'x-ray-extremity',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzoLAO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'X-ray (extremity)',
  },
  {
    subCategorySlug: 'injury-pain/sprains-strains-breaks',
    categorySlug: 'injury-pain',
    name: 'X-ray (pelvis)',
    description: '',
    slug: 'x-ray-pelvis',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzoLAO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'X-ray (pelvis)',
  },
  {
    subCategorySlug: 'injury-pain/sprains-strains-breaks',
    categorySlug: 'injury-pain',
    name: 'X-ray (spine)',
    description: '',
    slug: 'x-ray-spine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzoLAO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'X-ray (spine)',
  },
  {
    subCategorySlug: 'labs/allergies',
    categorySlug: 'labs',
    name: 'Allergy blood test',
    description: '',
    slug: 'allergy-blood-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '92MQAO,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'allergy_blood_test.svg',
    shortName: 'Allergy blood test',
  },
  {
    subCategorySlug: 'labs/allergies',
    categorySlug: 'labs',
    name: 'Allergy skin prick test',
    description: '',
    slug: 'allergy-skin-prick-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '90jQMp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Allergy skin prick test',
  },
  {
    subCategorySlug: 'labs/allergies',
    categorySlug: 'labs',
    name: 'Drug allergy test',
    description: '',
    slug: 'drug-allergy-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Ojxv3g,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Drug allergy test',
  },
  {
    subCategorySlug: 'labs/allergies',
    categorySlug: 'labs',
    name: 'Food allergy test',
    description: '',
    slug: 'food-allergy-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O67xJ9,pvNWBp,OrdzBg,92MQAO,90jQMp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Food allergy test',
  },
  {
    subCategorySlug: 'labs/allergies',
    categorySlug: 'labs',
    name: 'Penicillin allergy test',
    description: '',
    slug: 'penicillin-allergy-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pPo4ng,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Penicillin allergy test',
  },
  {
    subCategorySlug: 'labs/dna',
    categorySlug: 'labs',
    name: 'DNA health predisposition tests',
    description: '',
    slug: 'dna-health-predisposition-tests',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gY5J7g,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'DNA health predisposition tests',
  },
  {
    subCategorySlug: 'labs/dna',
    categorySlug: 'labs',
    name: 'DNA paternity test',
    description: '',
    slug: 'dna-paternity-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gY5J7g,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'DNA paternity test',
  },
  {
    subCategorySlug: 'labs/dna',
    categorySlug: 'labs',
    name: 'DNA sibling test',
    description: '',
    slug: 'dna-sibling-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gY5J7g,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'DNA sibling test',
  },
  {
    subCategorySlug: 'labs/energy-weight',
    categorySlug: 'labs',
    name: 'Thyroid disease screening',
    description: '',
    slug: 'thyroid-disease-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Ojx2ng,M9ZYmO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Thyroid disease screening',
  },
  {
    subCategorySlug: 'labs/energy-weight',
    categorySlug: 'labs',
    name: 'Vitamin D test',
    description: '',
    slug: 'vitamin-d-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gMmXDg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Vitamin D test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'A1C test (blood sugar levels)',
    description: '',
    slug: 'a1c-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'g7zxY9,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'al1c_test_glucose.svg',
    shortName: 'A1C test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Basic metabolic panel',
    description: '',
    slug: 'basic-metabolic-panel',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pGRjxg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Basic metabolic panel',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Cholestrerol & lipids test',
    description: '',
    slug: 'cholestrerol-lipids-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'ODGVnp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Cholestrerol & lipids test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Comprehensive metabolic panel',
    description: '',
    slug: 'comprehensive-metabolic-panel',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'OQo7eg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'metabolic_panel.svg',
    shortName: 'Metabolic panel',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Diabetes test',
    description: '',
    slug: 'diabetes-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pEZVyO,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Diabetes test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Drug test (10-panel test)',
    description: '',
    slug: 'drug-test-10-panel-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p3Mqk9,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Drug test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Drug test (5-panel test)',
    description: '',
    slug: 'drug-test-5-panel-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gaYEVg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Drug test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Flu test',
    description: '',
    slug: 'flu-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'XO6RO1,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Flu test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Glucose test',
    description: '',
    slug: 'glucose-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '692V9w,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Glucose test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Helicobacter pylori (H. pylori) test',
    description: '',
    slug: 'helicobacter-pylori-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'lgb5R9,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'H. pylori test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Hormone level test',
    description: '',
    slug: 'hormone-level-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9kq7dp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Hormone level test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Monkeypox PCR test',
    description: '',
    slug: 'monkeypox-pcr-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9wGek9',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Monkeypox PCR test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Mono test (Mononucleosis)',
    description: '',
    slug: 'mono-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '7OXVog,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Mono test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Pregnancy test',
    description: '',
    slug: 'pregnancy-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'RpRnpV,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'pregnancy_test.svg',
    shortName: 'Pregnancy test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Respiratory syncytial virus test (RSV)',
    description: '',
    slug: 'rsv-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'M9Zwqg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'RSV test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Strep throat test',
    description: '',
    slug: 'strep-throat-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'LOQ0p1,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Strep throat test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Tuberculosis (TB) test',
    description: '',
    slug: 'tb-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '09nR9x,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Tuberculosis test',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Urinalysis',
    description: '',
    slug: 'urinalysis',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'ag149D,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Urinalysis',
  },
  {
    subCategorySlug: 'labs/health-wellness',
    categorySlug: 'labs',
    name: 'Venom test',
    description: '',
    slug: 'venom-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p5BmbO,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Venom test',
  },
  {
    subCategorySlug: 'labs/sexual-health',
    categorySlug: 'labs',
    name: 'Chlamydia test',
    description: '',
    slug: 'chlamydia-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'g7zPY9,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'chlamydia.svg',
    shortName: 'Chlamydia test',
  },
  {
    subCategorySlug: 'labs/sexual-health',
    categorySlug: 'labs',
    name: 'Gonorrhea test',
    description: '',
    slug: 'gonorrhea-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O4PoVO,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Gonorrhea test',
  },
  {
    subCategorySlug: 'labs/sexual-health',
    categorySlug: 'labs',
    name: 'Hepatitis test',
    description: '',
    slug: 'hepatitis-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '90jY0p,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Hepatitis test',
  },
  {
    subCategorySlug: 'labs/sexual-health',
    categorySlug: 'labs',
    name: 'Herpes test',
    description: '',
    slug: 'herpes-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'OjxWng,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Herpes test',
  },
  {
    subCategorySlug: 'labs/sexual-health',
    categorySlug: 'labs',
    name: 'HIV screening',
    description: '',
    slug: 'hiv-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzo7AO,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'HIV screening',
  },
  {
    subCategorySlug: 'labs/sexual-health',
    categorySlug: 'labs',
    name: 'Syphilis test',
    description: '',
    slug: 'syphilis-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9Zd7Gp,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Syphilis test',
  },
  {
    subCategorySlug: 'labs/sexual-health',
    categorySlug: 'labs',
    name: 'Trichomonas test',
    description: '',
    slug: 'trichomonas-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'x9VQeO,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Trichomonas test',
  },
  {
    subCategorySlug: 'imaging/medical-imaging',
    categorySlug: 'imaging',
    name: 'CT scan',
    description: '',
    slug: 'ct-scan',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9NKvJg,OXeXK9',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'CT scan',
  },
  {
    subCategorySlug: 'imaging/medical-imaging',
    categorySlug: 'imaging',
    name: 'MRI',
    description: '',
    slug: 'mri',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'g1D4z9,9wGo39',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'MRI',
  },
  {
    subCategorySlug: 'imaging/medical-imaging',
    categorySlug: 'imaging',
    name: 'Ultrasound',
    description: '',
    slug: 'ultrasound',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pRoR6O,9W2rAO,gokXag',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Ultrasound',
  },
  {
    subCategorySlug: 'imaging/medical-imaging',
    categorySlug: 'imaging',
    name: 'X-ray (chest)',
    description: '',
    slug: 'x-ray-chest',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pGRbxg',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'X-ray (chest)',
  },
  {
    subCategorySlug: 'imaging/medical-imaging',
    categorySlug: 'imaging',
    name: 'X-ray (extremity)',
    description: '',
    slug: 'x-ray-extremity',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzoLAO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'X-ray (extremity)',
  },
  {
    subCategorySlug: 'imaging/medical-imaging',
    categorySlug: 'imaging',
    name: 'X-ray (pelvis)',
    description: '',
    slug: 'x-ray-pelvis',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzoLAO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'X-ray (pelvis)',
  },
  {
    subCategorySlug: 'imaging/medical-imaging',
    categorySlug: 'imaging',
    name: 'X-ray (spine)',
    description: '',
    slug: 'x-ray-spine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzoLAO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'X-ray (spine)',
  },
  {
    subCategorySlug: 'mens-womens/lgbtq-care',
    categorySlug: 'mens-womens',
    name: 'Hormone level test',
    description: '',
    slug: 'hormone-level-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9kq7dp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Hormone level test',
  },
  {
    subCategorySlug: 'mens-womens/lgbtq-care',
    categorySlug: 'mens-womens',
    name: 'Hormone therapy',
    description: '',
    slug: 'hormone-therapy',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p8rmd9',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Hormone therapy',
  },
  {
    subCategorySlug: 'mens-womens/lgbtq-care',
    categorySlug: 'mens-womens',
    name: 'LGBTQ+ care',
    description: '',
    slug: 'lgbtq-care',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pylG0g',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'LGBTQ+ care',
  },
  {
    subCategorySlug: 'mens-womens/mens-health',
    categorySlug: 'mens-womens',
    name: 'Flu vaccine',
    description: '',
    slug: 'flu-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'n9wG9K,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'flu_vaccine.svg',
    shortName: 'Flu vaccine',
  },
  {
    subCategorySlug: 'mens-womens/mens-health',
    categorySlug: 'mens-womens',
    name: 'HPV vaccine (Human Papillomavirus)',
    description: '',
    slug: 'hpv-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9AYln9,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'HPV vaccine',
  },
  {
    subCategorySlug: 'mens-womens/mens-health',
    categorySlug: 'mens-womens',
    name: 'IV hydration',
    description: '',
    slug: 'iv-hydration',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'lgbRgQ',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'iv_hydration.svg',
    shortName: 'IV hydration',
  },
  {
    subCategorySlug: 'mens-womens/mens-health',
    categorySlug: 'mens-womens',
    name: 'Skin cancer screening',
    description: '',
    slug: 'skin-cancer-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9qGr4p,pvNABp',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Skin cancer screening',
  },
  {
    subCategorySlug: 'mens-womens/mens-health',
    categorySlug: 'mens-womens',
    name: 'Testosterone level test',
    description: '',
    slug: 'testosterone-level-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9kq7dp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Testosterone level test',
  },
  {
    subCategorySlug: 'mens-womens/mens-health',
    categorySlug: 'mens-womens',
    name: 'Vision test',
    description: '',
    slug: 'vision-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Yp8YEO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Vision test',
  },
  {
    subCategorySlug: 'mens-womens/mens-health',
    categorySlug: 'mens-womens',
    name: 'Work physicals',
    description: '',
    slug: 'work-physicals',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9nvvZ9',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Work physicals',
  },
  {
    subCategorySlug: 'mens-womens/sti',
    categorySlug: 'mens-womens',
    name: 'Chlamydia test',
    description: '',
    slug: 'chlamydia-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'g7zPY9,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'chlamydia.svg',
    shortName: 'Chlamydia test',
  },
  {
    subCategorySlug: 'mens-womens/sti',
    categorySlug: 'mens-womens',
    name: 'Genital herpes treatment',
    description: '',
    slug: 'genital-herpes-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Genital herpes treatment',
  },
  {
    subCategorySlug: 'mens-womens/sti',
    categorySlug: 'mens-womens',
    name: 'Gonorrhea test',
    description: '',
    slug: 'gonorrhea-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O4PoVO,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Gonorrhea test',
  },
  {
    subCategorySlug: 'mens-womens/sti',
    categorySlug: 'mens-womens',
    name: 'Hepatitis test',
    description: '',
    slug: 'hepatitis-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '90jY0p,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Hepatitis test',
  },
  {
    subCategorySlug: 'mens-womens/sti',
    categorySlug: 'mens-womens',
    name: 'Herpes test',
    description: '',
    slug: 'herpes-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'OjxWng,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Herpes test',
  },
  {
    subCategorySlug: 'mens-womens/sti',
    categorySlug: 'mens-womens',
    name: 'HIV screening',
    description: '',
    slug: 'hiv-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzo7AO,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'HIV screening',
  },
  {
    subCategorySlug: 'mens-womens/sti',
    categorySlug: 'mens-womens',
    name: 'Syphilis test',
    description: '',
    slug: 'syphilis-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9Zd7Gp,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Syphilis test',
  },
  {
    subCategorySlug: 'mens-womens/sti',
    categorySlug: 'mens-womens',
    name: 'Trichomonas test',
    description: '',
    slug: 'trichomonas-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'x9VQeO,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Trichomonas test',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Birth control consultation',
    description: '',
    slug: 'birth-control-consultation',
    telemed: false,
    inPerson: false,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pPo0ng',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Birth control consultation',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Cervical screening',
    description: '',
    slug: 'cervical-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9ZdVvp,M9ZYmO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Cervical screening',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Estrogen level test',
    description: '',
    slug: 'estrogen-level-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9kq7dp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Estrogen level test',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Flu vaccine',
    description: '',
    slug: 'flu-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'n9wG9K,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Flu vaccine',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'HPV vaccine (Human Papillomavirus)',
    description: '',
    slug: 'hpv-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9AYln9,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'HPV vaccine',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Pap smear',
    description: '',
    slug: 'pap-smear',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gmY4vg',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Pap smear',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Pelvic exam',
    description: '',
    slug: 'pelvic-exam',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '59eVgw',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Pelvic exam',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Pregnancy test',
    description: '',
    slug: 'pregnancy-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'RpRnpV,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'pregnancy_test.svg',
    shortName: 'Pregnancy test',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Skin cancer screening',
    description: '',
    slug: 'skin-cancer-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9qGr4p,pvNABp',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Skin cancer screening',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Ultrasound',
    description: '',
    slug: 'ultrasound',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pRoR6O,9W2rAO,gokXag',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Ultrasound',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Urinalysis',
    description: '',
    slug: 'urinalysis',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'ag149D,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Urinalysis',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Urinary discomfort treatment',
    description: '',
    slug: 'urinary-discomfort-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p8rWQ9,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Urinary discomfort treatment',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Vaginal infection treatment',
    description: '',
    slug: 'vaginal-infection-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pylEqg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Vaginal infection treatment',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Vision test',
    description: '',
    slug: 'vision-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Yp8YEO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Vision test',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Woman wellness check-up',
    description: '',
    slug: 'woman-wellness-check-up',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '19N7gQ,9AYm09',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Woman wellness check-up',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Work physicals',
    description: '',
    slug: 'work-physicals',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9nvvZ9',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Work physicals',
  },
  {
    subCategorySlug: 'mens-womens/womens-health',
    categorySlug: 'mens-womens',
    name: 'Yeast infection treatment',
    description: '',
    slug: 'yeast-infection-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Yeast infection treatment',
  },
  {
    subCategorySlug: 'exams-screenings/occupational-medicine',
    categorySlug: 'exams-screenings',
    name: 'DOT physical (Department of Transportation)',
    description: '',
    slug: 'dot-physical',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '7OXopm',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'DOT physical',
  },
  {
    subCategorySlug: 'exams-screenings/occupational-medicine',
    categorySlug: 'exams-screenings',
    name: 'Drug screening (10-panel test)',
    description: '',
    slug: 'drug-screening-10-panel-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'p3Mqk9,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Drug screening',
  },
  {
    subCategorySlug: 'exams-screenings/occupational-medicine',
    categorySlug: 'exams-screenings',
    name: 'Drug screening (5-panel test)',
    description: '',
    slug: 'drug-screening-5-panel-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gaYEVg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Drug screening',
  },
  {
    subCategorySlug: 'exams-screenings/occupational-medicine',
    categorySlug: 'exams-screenings',
    name: 'Pulmonary function test',
    description: '',
    slug: 'pulmonary-function-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'lgb5W9',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Pulmonary function test',
  },
  {
    subCategorySlug: 'exams-screenings/occupational-medicine',
    categorySlug: 'exams-screenings',
    name: 'Work physicals',
    description: '',
    slug: 'work-physicals',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9nvvZ9',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Work physicals',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Annual check-up',
    description: '',
    slug: 'annual-check-up',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'g7zz49,ODGGZp',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Annual check-up',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Annual physical',
    description: '',
    slug: 'annual-physical',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'ODGGZp,g7zz49',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'wellness_visit.svg',
    shortName: 'Annual physical',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Baby wellness check-up',
    description: '',
    slug: 'baby-wellness-check-up',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'vOJrOm',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Baby wellness check-up',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Camp physical',
    description: '',
    slug: 'camp-physical',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gMmmNg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Camp physical',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'DOT physical (Department of Transportation)',
    description: '',
    slug: 'dot-physical',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '7OXopm',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'DOT physical',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Eye exam',
    description: '',
    slug: 'eye-exam',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gbPvxO,9nvN39',
    assumeOfferedByAllClinics: false,
    popular: true,
    hidden: false,
    svg: 'eye_exam.svg',
    shortName: 'Eye exam',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Pediatric physical',
    description: '',
    slug: 'pediatric-physical',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'V9W0g4',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Pediatric physical',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Pelvic exam',
    description: '',
    slug: 'pelvic-exam',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '59eVgw',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Pelvic exam',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Physical exam',
    description: '',
    slug: 'physical-exam',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'DODA9z',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Physical exam',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'School physical',
    description: '',
    slug: 'school-physical',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Vg7v9M',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'school_exam.svg',
    shortName: 'School physical',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Sports physical',
    description: '',
    slug: 'sports-physical',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Vg7v9M,MgYA4g',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Sports physical',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Woman wellness check-up',
    description: '',
    slug: 'woman-wellness-check-up',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '19N7gQ,9AYm09',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Woman wellness check-up',
  },
  {
    subCategorySlug: 'exams-screenings/physicals-exams',
    categorySlug: 'exams-screenings',
    name: 'Work physicals',
    description: '',
    slug: 'work-physicals',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9nvvZ9',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Work physicals',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Allergy blood test',
    description: '',
    slug: 'allergy-blood-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '92MQAO,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Allergy blood test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Allergy skin prick test',
    description: '',
    slug: 'allergy-skin-prick-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '90jQMp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Allergy skin prick test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Basic metabolic panel',
    description: '',
    slug: 'basic-metabolic-panel',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pGRjxg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Basic metabolic panel',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Cervical screening',
    description: '',
    slug: 'cervical-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9ZdVvp,M9ZYmO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Cervical screening',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Cholestrerol & lipids test',
    description: '',
    slug: 'cholestrerol-lipids-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'ODGVnp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Cholestrerol & lipids test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Comprehensive metabolic panel',
    description: '',
    slug: 'comprehensive-metabolic-panel',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'OQo7eg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Comprehensive metabolic panel',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Diabetes test',
    description: '',
    slug: 'diabetes-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pEZVyO,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Diabetes test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'EKG test',
    description: '',
    slug: 'ekg-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'qpd2N9',
    assumeOfferedByAllClinics: false,
    popular: true,
    hidden: false,
    svg: 'ekg.svg',
    shortName: 'EKG test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Food allergy test',
    description: '',
    slug: 'food-allergy-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O67xJ9,pvNWBp,OrdzBg,92MQAO,90jQMp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Food allergy test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Glucose test',
    description: '',
    slug: 'glucose-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '692V9w,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'al1c_test_glucose.svg',
    shortName: 'Glucose test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Gonorrhea test',
    description: '',
    slug: 'gonorrhea-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O4PoVO,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Gonorrhea test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Hepatitis test',
    description: '',
    slug: 'hepatitis-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '90jY0p,gaYvGg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Hepatitis test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Pap smear',
    description: '',
    slug: 'pap-smear',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gmY4vg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Pap smear',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Skin cancer screening',
    description: '',
    slug: 'skin-cancer-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9qGr4p,pvNABp',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Skin cancer screening',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Syphilis test',
    description: '',
    slug: 'syphilis-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9Zd7Gp,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Syphilis test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Thyroid disease screening',
    description: '',
    slug: 'thyroid-disease-screening',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Ojx2ng,M9ZYmO',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Thyroid disease screening',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Tuberculosis (TB) test',
    description: '',
    slug: 'tb-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '09nR9x,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Tuberculosis (TB) test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Ultrasound',
    description: '',
    slug: 'ultrasound',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pRoR6O,9W2rAO,gokXag',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Ultrasound',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Urinalysis',
    description: '',
    slug: 'urinalysis',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'ag149D,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Urinalysis',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Vision test',
    description: '',
    slug: 'vision-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Yp8YEO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Vision test',
  },
  {
    subCategorySlug: 'exams-screenings/tests-screenings',
    categorySlug: 'exams-screenings',
    name: 'Vitamin D test',
    description: '',
    slug: 'vitamin-d-test',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gMmXDg,M9ZYmO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Vitamin D test',
  },
  {
    subCategorySlug: 'skin-health/acne-rosacea-eczema-psoriasis',
    categorySlug: 'skin-health',
    name: 'Acne treatment',
    description: '',
    slug: 'acne-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'OrdkBg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Acne treatment',
  },
  {
    subCategorySlug: 'skin-health/acne-rosacea-eczema-psoriasis',
    categorySlug: 'skin-health',
    name: 'Eczema treatment (Atopic dermatitis)',
    description: '',
    slug: 'eczema-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'O67Vj9,ODGmWp,gY56vg',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Eczema treatment',
  },
  {
    subCategorySlug: 'skin-health/acne-rosacea-eczema-psoriasis',
    categorySlug: 'skin-health',
    name: 'Psoriasis treatment',
    description: '',
    slug: 'psoriasis-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gB70Qp',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'psoriasis.svg',
    shortName: 'Psoriasis treatment',
  },
  {
    subCategorySlug: 'skin-health/acne-rosacea-eczema-psoriasis',
    categorySlug: 'skin-health',
    name: 'Rosacea treatment',
    description: '',
    slug: 'rosacea-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Rosacea treatment',
  },
  {
    subCategorySlug: 'skin-health/burns-blisters-wounds',
    categorySlug: 'skin-health',
    name: 'Burn treatment',
    description: '',
    slug: 'burn-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '7OX7op,qgMP9o,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Burn treatment',
  },
  {
    subCategorySlug: 'skin-health/burns-blisters-wounds',
    categorySlug: 'skin-health',
    name: 'Scar treatment',
    description: '',
    slug: 'scar-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9W2wAO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: true,
    svg: '',
    shortName: 'Scar treatment',
  },
  {
    subCategorySlug: 'skin-health/burns-blisters-wounds',
    categorySlug: 'skin-health',
    name: 'Stitches (laceration repair)',
    description: '',
    slug: 'stitches-laceration-repair',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Vg7Bv9,qgMP9o',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Stitches',
  },
  {
    subCategorySlug: 'skin-health/burns-blisters-wounds',
    categorySlug: 'skin-health',
    name: 'Sunburn treatment',
    description: '',
    slug: 'sunburn-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '7OX7op,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Sunburn treatment',
  },
  {
    subCategorySlug: 'skin-health/burns-blisters-wounds',
    categorySlug: 'skin-health',
    name: 'Wound care',
    description: '',
    slug: 'wound-care',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'qgMP9o,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Wound care',
  },
  {
    subCategorySlug: 'skin-health/cysts-abscesses',
    categorySlug: 'skin-health',
    name: 'Abscess treatment',
    description: '',
    slug: 'abscess-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'V9WG09,9L4VN9,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Abscess treatment',
  },
  {
    subCategorySlug: 'skin-health/cysts-abscesses',
    categorySlug: 'skin-health',
    name: 'Cyst treatment',
    description: '',
    slug: 'cyst-treatment',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'MgY49G,pGR0Kg,9L4VN9,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Cyst treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: "Athlete's foot treatment",
    description: '',
    slug: 'athlete-foot-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: "Athlete's foot treatment",
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Bee sting treatment',
    description: '',
    slug: 'bee-sting-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'OQoVZg,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'bee_sting.svg',
    shortName: 'Bee sting treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Bug bite treatment',
    description: '',
    slug: 'bug-bite-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Bug bite treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Chickenpox treatment',
    description: '',
    slug: 'chickenpox-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Chickenpox treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Dermatitis treatment',
    description: '',
    slug: 'dermatitis-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pzoQEO,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Dermatitis treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Hives treatment',
    description: '',
    slug: 'hives-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9qGB4p,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Hives treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Impetigo treatment',
    description: '',
    slug: 'impetigo-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Impetigo treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Insect sting treatment',
    description: '',
    slug: 'insect-sting-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'gmYLvg,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Insect sting treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Poisonous plant rash treatment (Ivy, Oak, Sumac)',
    description: '',
    slug: 'poisonous-plant-rash-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'poison_ivy.svg',
    shortName: 'Poison ivy treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Rash consultation',
    description: '',
    slug: 'rash-consultation',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEyYO,goknag,,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Rash consultation',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Ringworm treatment',
    description: '',
    slug: 'ringworm-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'ring_worm.svg',
    shortName: 'Ringworm treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Shingles treatment',
    description: '',
    slug: 'shingles-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,goknag',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'shingles.svg',
    shortName: 'Shingles treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Shingles vaccine',
    description: '',
    slug: 'shingles-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9K11Np,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Shingles vaccine',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Tick bite treatment',
    description: '',
    slug: 'tick-bite-treatment',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Tick bite treatment',
  },
  {
    subCategorySlug: 'skin-health/rash-bites-warts',
    categorySlug: 'skin-health',
    name: 'Wart evaluation',
    description: '',
    slug: 'wart-evaluation',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO,9L4VN9',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Wart evaluation',
  },
  {
    subCategorySlug: 'skin-health/splinter-stitch-staple',
    categorySlug: 'skin-health',
    name: 'Splinter removal',
    description: '',
    slug: 'splinter-removal',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Splinter removal',
  },
  {
    subCategorySlug: 'skin-health/splinter-stitch-staple',
    categorySlug: 'skin-health',
    name: 'Stitch & staple removal',
    description: '',
    slug: 'stitch-staple-removal',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: true,
    hidden: false,
    svg: 'stitches.svg',
    shortName: 'Stitch & staple removal',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'Chickenpox vaccine',
    description: '',
    slug: 'chickenpox-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'pdEEBO,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Chickenpox vaccine',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'COVID-19 booster',
    description: '',
    slug: 'covid-booster',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9K1eBp,9qG5Kp,9L41d9,gmYrng',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 booster',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'COVID-19 vaccine',
    description: '',
    slug: 'covid-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9K1eBp,9qG5Kp,9L41d9,gmYrng',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 vaccine',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'DTaP vaccine (Diphtheria, Tetanus, Pertussis)',
    description: '',
    slug: 'dtap-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'Olqqy9,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'DTaP vaccine',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'Flu vaccine',
    description: '',
    slug: 'flu-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: 'n9wG9K,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Flu vaccine',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'Hepatitis vaccine',
    description: '',
    slug: 'hepatitis-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9qGGLp,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Hepatitis vaccine',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'HPV vaccine (Human Papillomavirus)',
    description: '',
    slug: 'hpv-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9AYln9,pvNN2p',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'HPV vaccine',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'Measles vaccine',
    description: '',
    slug: 'measles-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9L44e9,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Measles vaccine',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'Monkeypox vaccine (JYNNEOS)',
    description: '',
    slug: 'monkeypox-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9NKmGg',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Monkeypox vaccine',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'Shingles vaccine',
    description: '',
    slug: 'shingles-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9K11Np,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Shingles vaccine',
  },
  {
    subCategorySlug: 'vaccines/disease-prevention',
    categorySlug: 'vaccines',
    name: 'Tetanus vaccine',
    description: '',
    slug: 'tetanus-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '8pEqpX,pvNN2p',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Tetanus vaccine',
  },
  {
    subCategorySlug: 'vaccines/travel',
    categorySlug: 'vaccines',
    name: 'COVID-19 vaccine',
    description: '',
    slug: 'covid-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9K1eBp,9qG5Kp,9L41d9,gmYrng',
    assumeOfferedByAllClinics: false,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'COVID-19 vaccine',
  },
  {
    subCategorySlug: 'vaccines/travel',
    categorySlug: 'vaccines',
    name: 'Travel vaccine consultation',
    description: '',
    slug: 'travel-vaccines',
    telemed: true,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '69x1g5,pdEvQO',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Travel vaccine consultation',
  },
  {
    subCategorySlug: 'vaccines/travel',
    categorySlug: 'vaccines',
    name: 'Typhoid vaccine',
    description: '',
    slug: 'typhoid-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9VJJz9,69x1g5',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Typhoid vaccine',
  },
  {
    subCategorySlug: 'vaccines/travel',
    categorySlug: 'vaccines',
    name: 'Yellow fever vaccine',
    description: '',
    slug: 'yellow-fever-vaccine',
    telemed: false,
    inPerson: true,
    symptomChecker: false,
    asyncChat: false,
    serviceIds: '9AYYn9,69x1g5',
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
    shortName: 'Yellow fever vaccine',
  },
  {
    sortOrder: 1,
    subCategorySlug: 'mental-health/alma',
    categorySlug: 'mental-health',
    href: AlmaUrls.search.landing,
    externalLink: true,
    name: 'Individual therapy',
    shortName: 'Individual therapy',
    slug: 'individual-therapy',
    description: '',
    telemed: true,
    inPerson: false,
    symptomChecker: false,
    asyncChat: false,
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
  },

  {
    sortOrder: 3,
    subCategorySlug: 'mental-health/alma',
    categorySlug: 'mental-health',
    href: AlmaUrls.search.landing,
    externalLink: true,
    name: 'Family therapy',
    shortName: 'Family therapy',
    slug: 'family-therapy',
    description: '',
    telemed: true,
    inPerson: false,
    symptomChecker: false,
    asyncChat: false,
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
  },
  {
    sortOrder: 5,
    subCategorySlug: 'mental-health/alma',
    categorySlug: 'mental-health',
    href: AlmaUrls.search.landing,
    externalLink: true,
    name: 'Medication management',
    shortName: 'Medication management',
    slug: 'medication-management',
    description: '',
    telemed: true,
    inPerson: false,
    symptomChecker: false,
    asyncChat: false,
    assumeOfferedByAllClinics: true,
    popular: false,
    hidden: false,
    svg: '',
  },
];
